export interface YoutubeVideoProps {
  videoId?: string
}

export enum PLAYER_VARS {
  rel = 0,
  autoplay = 0,
  showinfo = 0,
  controls = 1,
  playsinline = 1,
  enablejsapi = 1,
}
